angular.module('internal.home',[])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('internal.home', {
            url: '/home',
            views: {
                'content': {
                    templateUrl: 'js/internal/home/home.view.html',
                    controller:'HomeCtrl',
                    controllerAs:'vm'
                }
            }
        });
    }]);